import React from "react";
import { Redirect, Route } from "react-router-dom";
import config from "../config/config.json";

const PrivateRouteOfficialNumber = ({ component: Component, ...rest }) => {
    return rest.location.state !== undefined ? (
        <Route {...rest} render={(props) => <Component {...props} />} />
    ) : (
        <Route
            {...rest}
            render={(props) => (
                <Redirect
                    to={{
                        pathname: `${
                            process.env.PUBLIC_URL +
                            config.route.DASHBOARD_CIVIC.CIVIC
                        }`,
                    }}
                />
            )}
        />
    );
};

export const PrivateRouteOfficialNumberEnterprise = ({
    component: Component,
    ...rest
}) => {
    return rest.location.state !== undefined ? (
        <>
            <Route {...rest} render={(props) => <Component {...props} />} />
        </>
    ) : (
        <Route
            {...rest}
            render={(props) => (
                <Redirect
                    to={{
                        pathname: `${
                            process.env.PUBLIC_URL +
                            config.route.DASHBOARD_ENTERPRISE.ENTERPRISE
                        }`,
                    }}
                />
            )}
        />
    );
};

export default PrivateRouteOfficialNumber;
